<template>
<drawer :opened.sync="visible" class="qc-data-import-drawer">
  <template slot="header">导入质控数据</template>
  <template slot="body">
    <el-form v-if="visible" ref="form" :model="model" :rules="rules" label-width="85px" @keydown.native.enter.prevent>
      <el-form-item label="站房名称" prop="siteName">
        {{site.name}}
      </el-form-item>

      <el-form-item label="日期选择" prop="dataTime">
        <el-date-picker
          v-model="model.dataTime"
          :clearable="false"
          type="date"
          format="yyyy-MM-dd"
          value-format="yyyy-MM-dd"
        />
      </el-form-item>

      <el-form-item label="质控类型" prop="type">
        <el-cascader
          v-model="model.type"
          :options="qcDeviceList"
          :props="{expandTrigger:'hover'}"
          style="width:220px;"
        />
      </el-form-item>

      <el-form-item label="文件上传">
        <el-upload
          ref="upload"
          :action="`/quality/control/file?siteId=${encodeURIComponent(model.siteId)}&dataTime=${encodeURIComponent(model.dataTime)}&qualityFactorCategoryId=${encodeURIComponent(model.type[0])}&type=${model.type[1]}`"
          :auto-upload="false"
          :multiple="false"
          drag
          accept=".csv"
          class="upload"
          :http-request="onUploadBtnClick"
        >
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        </el-upload>
      </el-form-item>
    </el-form>

    <q-c-factor-select-dialog ref="qcFactorSelectDialog" @finished="onFactorSelectFinished" />
  </template>

  <template slot="footer">
    <el-button type="orange" class="btn save-btn" @click="handleImport">导入</el-button>
    <el-button type="orange" plain class="btn save-continue-btn" @click="handleImportContinue">导入并继续</el-button>
    <el-button class="btn" @click="downloadTemplate">下载模板</el-button>
    <a class="cancel-btn btn" @click="handleClose">关闭</a>
  </template>
</drawer>
</template>

<script>
import QCFactorSelectDialog from './QCFactorSelectDialog'
import CSVDownloader from '../../../utils/CSVDownloader'
import BaseStore from '../../../components/BaseStore'

export default {
  name: 'QCDataImport',
  extends: BaseStore,
  components: {
    QCFactorSelectDialog
  },
  props: {
    site: Object,
    qcDeviceList: Array,
    query: Object
  },
  data () {
    return {
      token: '',
      visible: false,
      model: {
        siteId: '',
        dataTime: new Date().format('YYYY-MM-DD'),
        type: []
      },
      rules: {
        dataTime: [{
          required: true,
          trigger: 'blur',
          message: '请输入日期'
        }]
      }
    }
  },
  methods: {
    open () {
      this.initModel()
      this.visible = true
    },
    initModel () {
      let {model, query} = this
      model.siteId = this.site.id
      model.dataTime = new Date().format('YYYY-MM-DD')
      model.type = [query.deviceCategoryId, query.checkItemId]

      // this.clearFiles()
    },
    clearFiles () {
      this.$refs.upload.clearFiles()
    },
    handleClose () {
      this.visible = false
    },
    upload () {
      let refForm = this.$refs.form

      refForm && refForm.validate(flag => {
        if (!flag) {
          return
        }

        this.$refs.upload.submit()
      })
    },
    handleImport () {
      this.isNeedClose = true
      this.upload()
    },
    handleImportContinue () {
      this.isNeedClose = false
      this.upload()
    },
    downloadTemplate () {
      CSVDownloader([['factorName', 'value']], '质控分析模板.csv')
    },
    onUploadBtnClick (uploadOpts) {
      clearTimeout(this.uploadTimer)

      this.uploadTimer = setTimeout(() => {
        this.changeLoadStatus(true)

        this.$api.Upload.upload(uploadOpts).then(data => {
          this.clearFiles()

          if (data.length === 0) {
            this.saveClose()
          } else {
            this.$refs.qcFactorSelectDialog.dataListChanged(data)
          }
        }).catch(console.error).finally(() => {
          this.changeLoadStatus(false)
        })
      }, 0)
    },
    onFactorSelectFinished () {
      this.saveClose()
    },
    saveClose () {
      if (this.isNeedClose) {
        this.handleClose()
      }

      this.$notify({
        title: '成功',
        message: '导入成功',
        type: 'success',
        position: 'bottom-right'
      })

      this.$emit('imported-success')
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/05QC-Analysis/00Data/QCDataImport.vue